import React from 'react'
import { useTranslation } from 'react-i18next'

import {
  CheckboxInputStyle,
  UncontrolledRadioInput,
} from '@src/components/Inputs'
import { LocationOverlayContainer } from '@src/components/LocationOverlay/LocationOverlayStyles'
import {
  MobileNavigationPopoverContentWrapper,
  MobileNavigationPopoverContent,
  MobileNavigationPopoverFooter,
  MobileNavigationPopoverFooterContent,
  MobileNavigationResetLink,
  DoneButton,
  OptionContentLabels,
  OptionContentText,
  OptionLabel,
  PopoverOptionContainer,
} from '@src/components/BottomSheet/BottomSheet.styles'
import { DeliveryZone } from '@src/graphql-types'
import { BottomSheet } from '../BottomSheet/BottomSheet'
import { useBottomSheetStack } from '../../hooks/useBottomSheetStack/useBottomSheetStack'

export const ZonesPopover: React.FC<{
  onDone: (zoneId: string) => void
  selectedZoneId?: string | null
  availableZones: Pick<DeliveryZone, 'id' | 'name'>[]
}> = ({ onDone, selectedZoneId = null, availableZones }) => {
  const { t } = useTranslation('serviceNavigation')
  const { deliveryZoneBottomSheetController } = useBottomSheetStack()
  const [zoneId, setZoneId] = React.useState<string | null>(selectedZoneId)

  const onDismiss = () => {
    setZoneId(selectedZoneId)
  }

  return (
    <BottomSheet
      bottomSheetController={deliveryZoneBottomSheetController}
      onDismiss={onDismiss}
      maxWidth={584}
      showBackdrop={false}
    >
      <MobileNavigationPopoverContentWrapper>
        <MobileNavigationPopoverContent>
          <LocationOverlayContainer>
            {availableZones.map(({ id, name }) => (
              <PopoverOptionContainer key={id}>
                <UncontrolledRadioInput
                  label={
                    <>
                      <OptionLabel>
                        <OptionContentLabels>
                          <OptionContentText>{name}</OptionContentText>
                        </OptionContentLabels>
                      </OptionLabel>
                    </>
                  }
                  style={CheckboxInputStyle.TICK}
                  checked={zoneId === id}
                  onClick={() => {
                    setZoneId(id)
                  }}
                />
              </PopoverOptionContainer>
            ))}
          </LocationOverlayContainer>
        </MobileNavigationPopoverContent>
      </MobileNavigationPopoverContentWrapper>
      <MobileNavigationPopoverFooter>
        <MobileNavigationPopoverFooterContent>
          <MobileNavigationResetLink onClick={onDismiss}>
            {t('cancel')}
          </MobileNavigationResetLink>

          <DoneButton
            content={t('done')}
            width="180px"
            onClick={() => zoneId && onDone(zoneId)}
            type={'button'}
            disabled={!zoneId}
          />
        </MobileNavigationPopoverFooterContent>
      </MobileNavigationPopoverFooter>
    </BottomSheet>
  )
}
